import React from 'react';
import { Overview } from '../../../api/cafAutomation';

export const AttentionCard: React.FC<{ overview: Overview; onOpenAttention: () => void; onOpenRuns: () => void }> =
  ({ overview, onOpenAttention, onOpenRuns }) => {
    if (!overview.capabilities?.runs || !overview.activation || !overview.evidence) return null;
    return <section className="ui-card" aria-label="Workflow activity">
      <div className="ui-card__header"><h2 className="ui-card__title">Workflow activity</h2></div>
      <div className="ui-card__body cur-stack">
        <p>{overview.execution ? `${overview.execution.started} runs started · ${overview.execution.completed} finished` : 'Run totals are unavailable in historical Phase 1 evidence.'}</p>
        <div className="cur-inline">
          <button type="button" className="ui-btn ui-btn--secondary ui-btn--sm" onClick={onOpenAttention}>Needs attention</button>
          <button type="button" className="ui-btn ui-btn--secondary ui-btn--sm" onClick={onOpenRuns}>See runs</button>
        </div>
      </div>
    </section>;
  };
